import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Navbar, Nav, Container } from 'react-bootstrap'
import SocialIcons from '../ui/SocialIcons'

const Header = () => {
  const [isSticky, setIsSticky] = useState(false)
  const [expanded, setExpanded] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 200)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Close mobile menu on route change
  useEffect(() => {
    setExpanded(false)
  }, [location])

  const isHomePage = location.pathname === '/'

  const scrollToSection = (sectionId: string) => {
    if (isHomePage) {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <div className="header header-1">
      <div className={`navbar-main ${isSticky ? 'stiky' : ''}`}>
        <Container>
          <Navbar 
            expand="lg" 
            expanded={expanded}
            onToggle={() => setExpanded(!expanded)}
          >
            <Link to="/" className="navbar-brand">
              <img src="/images/relentless images/relentless-logo.jpg" alt="Relentless Performance Training" />
            </Link>
            <Navbar.Toggle aria-controls="navbarNavDropdown">
              <span className="navbar-toggler-icon"></span>
            </Navbar.Toggle>
            <Navbar.Collapse id="navbarNavDropdown">
              <Nav className="ml-auto">
                <Nav.Item>
                  <Link to="/" className="nav-link">HOME</Link>
                </Nav.Item>
                {isHomePage ? (
                  <>
                    <Nav.Item>
                      <a 
                        href="#about" 
                        className="nav-link"
                        onClick={(e) => {
                          e.preventDefault()
                          scrollToSection('about')
                        }}
                      >
                        ABOUT US
                      </a>
                    </Nav.Item>
                    <Nav.Item>
                      <a 
                        href="#classes" 
                        className="nav-link"
                        onClick={(e) => {
                          e.preventDefault()
                          scrollToSection('classes')
                        }}
                      >
                        CLASSES
                      </a>
                    </Nav.Item>
                    <Nav.Item>
                      <a 
                        href="#gallery" 
                        className="nav-link"
                        onClick={(e) => {
                          e.preventDefault()
                          scrollToSection('gallery')
                        }}
                      >
                        GALLERY
                      </a>
                    </Nav.Item>
                    <Nav.Item>
                      <a 
                        href="#blogs" 
                        className="nav-link"
                        onClick={(e) => {
                          e.preventDefault()
                          scrollToSection('blogs')
                        }}
                      >
                        RELENTLESS BLOGS
                      </a>
                    </Nav.Item>
                    <Nav.Item>
                      <a 
                        href="#contact" 
                        className="nav-link"
                        onClick={(e) => {
                          e.preventDefault()
                          scrollToSection('contact')
                        }}
                      >
                        SIGN UP!
                      </a>
                    </Nav.Item>
                  </>
                ) : (
                  <>
                    <Nav.Item>
                      <Link to="/about" className="nav-link">ABOUT US</Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Link to="/classes" className="nav-link">CLASSES</Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Link to="/gallery" className="nav-link">GALLERY</Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Link to="/testimonials" className="nav-link">TESTIMONIALS</Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Link to="/contact" className="nav-link">CONTACT</Link>
                    </Nav.Item>
                  </>
                )}
                <Nav.Item>
                  <a 
                    href="https://relentless-performance-training.square.site/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="nav-link"
                  >
                    ONLINE STORE
                  </a>
                </Nav.Item>
                <Nav.Item>
                  <a 
                    href="https://app.buildfire.com/promo/Relentless%20Movement" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="nav-link"
                  >
                    NEW MOBILE APP!
                  </a>
                </Nav.Item>
              </Nav>
              <SocialIcons />
            </Navbar.Collapse>
          </Navbar>
        </Container>
      </div>
    </div>
  )
}

export default Header


